import React from 'react';

import DoctorCard from '@app/components/Pages/Home/DoctorCard';
import { Doctor } from '@app/objects/Doctor';
import SliderWithObserver from '@app/components/UI/SliderWithObserver/SliderWithObserver';

const giftsSlickSettings = {
	slidesToShow: 5,
	className: 'home-page-gifts',
	arrows: true,
	dots: false,
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};

interface Props {
	doctors: Array<Doctor>;
	className?: string;
}

const DoctorSlider: React.FC<Props> = ({ doctors, className = 'home-page-gifts__item' }) => {
	return <SliderWithObserver
		sliderProps={{ ...giftsSlickSettings, dots: true }}
		className="slider-arrows doctor-card-list mobile-show doctors-slider"
	>
		{
			doctors.map((item) =>
				<div key={item.id} className={className}>
					<DoctorCard item={item} />
				</div>)
		}
	</SliderWithObserver>;
};

export default DoctorSlider;
